import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDNrY1oLikl0qrieiKeYToSj29Lg71-d6M",
    authDomain: "axe-canada-app.firebaseapp.com",
    projectId: "axe-canada-app",
    storageBucket: "axe-canada-app.firebasestorage.app",
    messagingSenderId: "854275578496",
    appId: "1:854275578496:web:74497af5dc794e6b11e465"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// --- CACHE OFFLINE (Performance) ---
// Utilise la nouvelle méthode persistante recommandée pour web Firebase SDK 10+
// Les données Firestore déjà chargées sont mises en cache dans IndexedDB
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export default app;
